export const defaultToastConfig = {
  wap: {
    theme: '',
    duration: 2000
  },
  desktop: {
    theme: 'light',
    duration: 3000
  }
}
